import { ReactElement } from 'react';

import { HeaderW, PageTitle } from './styled';

interface PageHeaderProps {
  pageTitle: ReactElement | string;
}

export function PageHeader({ pageTitle }: PageHeaderProps): ReactElement {
  return (
    <HeaderW>
      <PageTitle>{pageTitle}</PageTitle>
    </HeaderW>
  );
}
